import React, { useEffect, useRef, useState } from "react";
import { Layout } from "antd";
import { Scrollbar } from "smooth-scrollbar-react";
import type { Scrollbar as BaseScrollbar } from "smooth-scrollbar/scrollbar";

const { Sider } = Layout;

import { connect } from "react-redux";

import { leftMenuToggle } from 'store/actions/home'

import Menus from "./Menus";
import FasterMenus from "./FasterMenus";
import ResponsiveDesign from "./responsiveDesigns";
import useResponsiveWidth from "hooks/useResponsiveWidth";
import SettingsLogoutResponsive from "./settingsLogoutResponsive";

const Index: React.FC<any> = ({ leftMenuStatus }) => {

    const responsiveWidth = useResponsiveWidth();
    const scrollbar = useRef<BaseScrollbar | null>(null);
    const language = localStorage.getItem("i18nextLng")

    return (
        <>
            <Sider
                className='side_bar '
                theme='light'
                width={240}
                collapsedWidth={responsiveWidth < 650 ? 0 : 49}
                trigger={null}
                collapsible
                collapsed={leftMenuStatus} >

                <div className={(responsiveWidth < 992 && leftMenuStatus) ? 'full side_top_mobile flex' :  'full side_top flex'}>

                    <Scrollbar
                        ref={scrollbar}
                        plugins={{
                            disableScroll: { direction: 'x' }
                        }}
                        alwaysShowTracks={false}
                    >
                        {responsiveWidth <= 992 && !leftMenuStatus && <ResponsiveDesign />}
                        <Menus />
                        <FasterMenus />
                    </Scrollbar>

                </div>
                {
                    responsiveWidth < 650 &&
                    <div className='responsiveSettingLogoutContainer'>
                        <SettingsLogoutResponsive />
                    </div>
                }
                {
                    !leftMenuStatus && <div className='copyright_box' style={{ textAlign: 'center' }}>
                        <p >Copyright © {new Date().getFullYear()} All right reserved</p>
                        {
                            process.env.REACT_APP_VERSION && <p >Version №: {process.env.REACT_APP_VERSION}</p>
                        }
                    </div>
                }

            </Sider>
        </>
    )
}

const mapDispatchToProps = { leftMenuToggle }

const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
})

export default connect(mapStateToProps, mapDispatchToProps)(Index);
